import { ForkEffect, takeEvery } from 'redux-saga/effects';
import { Socket } from 'socket.io-client';

import { send } from '../send-request';
import {
  marketingConsentCampaignEligibleList,
  marketingConsentCampaignSend,
  marketingConsentCampaignSentList,
} from './reducer';

export function* watch(
  socket: Socket,
): Generator<ForkEffect<never>, void, string> {
  yield takeEvery(marketingConsentCampaignSend.type, send, socket);
  yield takeEvery(marketingConsentCampaignEligibleList.type, send, socket);
  yield takeEvery(marketingConsentCampaignSentList.type, send, socket);
}
